const options = {
  5: "bg-rose-300/5",
  10: "bg-rose-300/10",
  25: "bg-rose-300/25",
  50: "bg-rose-300/50",
  75: "bg-rose-300/75",
  90: "bg-rose-300/90",
  100: "bg-rose-300",
};

const from = {
  5: "from-rose-300/5",
  10: "from-rose-300/10",
  25: "from-rose-300/25",
  50: "from-rose-300/50",
  75: "from-rose-300/75",
  90: "from-rose-300/90",
  100: "from-rose-300",
};

export default function getBackgroundRose300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
